// Action types for fetching orders
export const FETCH_DOWNLOAD_BATCH_STATUS_REQUEST = 'FETCH_DOWNLOAD_BATCH_STATUS_REQUEST';
export const FETCH_DOWNLOAD_BATCH_STATUS_SUCCESS = 'FETCH_DOWNLOAD_BATCH_STATUS_SUCCESS';
export const FETCH_DOWNLOAD_BATCH_STATUS_FAILURE = 'FETCH_DOWNLOAD_BATCH_STATUS_FAILURE';
export const FETCH_DOWNLOAD_BATCH_STATUS_RESET = 'FETCH_DOWNLOAD_BATCH_STATUS_RESET';
// Fetch data actions
export const fetchDownloadBatchStatusRequest = (payload) => ({
    type: FETCH_DOWNLOAD_BATCH_STATUS_REQUEST,
    payload,
});
export const fetchDownloadBatchStatusSuccess = (payload) => ({
    type: FETCH_DOWNLOAD_BATCH_STATUS_SUCCESS,
    payload,
});
export const fetchDownloadBatchStatusFailure = (error) => ({
    type: FETCH_DOWNLOAD_BATCH_STATUS_FAILURE,
    payload: error,
});
export const fetchDownloadBatchStatusReset = () => ({
    type: FETCH_DOWNLOAD_BATCH_STATUS_RESET,
});
